const btn = {
  label: 'See More Equipment',
  Typography: 'No equipment found for this location'
}

export default btn;
